import React from 'react';
import { connect } from 'react-redux';
import history from '../../history';
import { popupBot } from '../../actions';
import GoogleAuth from './googleAuth';
import {Container, Row, Col } from 'react-bootstrap';

let timeoutLength2 = 5000;
class giroPlataforma extends React.Component {

    state = { mensaje: 'Vamos a iniciar nuestro trabajo' }

    timerIn = () => {
        this.timeout = setTimeout(() => {
            if (this.props.userDetail && this.props.userDetail.usuario)
                history.push('/dashboard');
            else {
                this.props.popupBot({ mensaje: "Hemos terminado nuestro periodo de pruebas, Comunicate con nosotros para continuar", sleep: 5000 });
                this.setState({ mensaje: 'Contactanos para continuar' });
            }
        }, timeoutLength2)
    }

    componentDidMount() {
        this.timerIn();
    }

    render() {

        return (

            <Container fluid className="centerIntro">
                <Row>
                    <Col md={{span:6, offset: 3 }} xs={{span:10, offset: 1 }} >
                        <div className="box" >
                            <h2>{this.state.mensaje}</h2>
                            <div className="loader9"></div>
                            <br></br>
                        </div >

                    </Col>
                  
                </Row>
                <Row>
                    <Col md={{span:2, offset: 5 }} xs={{span:8, offset: 2 }} >
                        <GoogleAuth />
                    </Col>
                    
                </Row>
            </Container>

        );
    }
};


const mapStateToProps = (state) => {
    return {
        userDetail: state.mainReducer.userDetail,
    };
};

export default connect(mapStateToProps, { popupBot })(giroPlataforma);